import React from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Button, Dialog } from '@mui/material';

interface JobAdSuccessDialogProps {
  open: boolean;
  onClose: () => void;
  answers: any;
  classes: any;
  adType: string;
  jobId?: string;
}

const JobAdSuccessDialog: React.FC<JobAdSuccessDialogProps> = ({
  open,
  onClose,
  answers,
  classes,
  adType,
  jobId
}) => (
  <Dialog classes={{ paper: classes.successDialog }} onClose={onClose} open={open}>
    <div className={classes.successCheck}>
      <CheckCircleIcon />
    </div>
    <h4>Success!</h4>
    <div className={classes.successDialogText}>
      {answers?.advertisement_id ? (
        <span>Your ad has been updated on {adType}</span>
      ) : (
        <span>Your ad has been posted to {adType}</span>
      )}
    </div>
    <div className={`${classes.dialogButtonContainer} ${classes.successDialogContainer}`}>
      <Button
        disableElevation
        className={classes.buttonSecondary}
        endIcon={<ChevronRightIcon />}
        onClick={() => {
          if (jobId) {
            location.href = `/admin/jobs/${jobId}/job_ads`;
          } else {
            window.history.back();
          }
        }}
      >
        Back to ads
      </Button>
    </div>
  </Dialog>
);

export default JobAdSuccessDialog;
